import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { isAdminHost, registerServiceWorker } from './pwa';
import './ui/tokens.css';
import './ui/base.css';
import './ui/ui.css';

registerServiceWorker();

// The admin host (admin.…) gets the admin, a lazy chunk of its own, so the
// app's first load never carries it. The Worker decides who may use it.
const AdminApp = lazy(() => import('./admin/AdminApp'));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isAdminHost() ? <Suspense fallback={null}><AdminApp /></Suspense> : <App />}
  </StrictMode>,
);
